<div class="menu-groups-page" *ngIf="isBaseRoute()">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">GRUPOS DE MENÚ</h1>
                <p class="page-subtitle text-muted">
                    Gestione los grupos del menú lateral: cree, edite y ordene. El orden define cómo se muestran en el sidebar.
                </p>
            </div>
            <div class="header-actions">
                <button mat-button (click)="onBack()" class="me-2" matTooltip="Volver a Módulos">
                    <mat-icon>arrow_back</mat-icon>
                    Volver
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    (click)="onCreate()"
                    matTooltip="Crear nuevo grupo de menú">
                    <mat-icon>add</mat-icon>
                    Nuevo
                </button>
            </div>
        </div>
    </div>

    <mat-card class="data-card">
        <mat-card-content>
            <div class="menu-groups-list-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort>

                        <!-- Nombre Column -->
                        <ng-container matColumnDef="nombre">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-0">
                                Nombre
                            </th>
                            <td mat-cell *matCellDef="let element" class="pl-0">
                                <div class="menu-group-info">
                                    <h6 class="mt-0 mb-0">{{ element.nombre }}</h6>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Orden Column -->
                        <ng-container matColumnDef="orden">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Orden
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.orden }}
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="text-end pr-0"></th>
                            <td mat-cell *matCellDef="let element" class="text-end pr-0">
                                <div class="action">
                                    <button type="button" mat-button class="p-0 min-w-auto lh-1 h-auto" (click)="editGroup(element)">
                                        <i class="ri-edit-line"></i>
                                    </button>
                                    <button type="button" mat-button class="p-0 min-w-auto lh-1 h-auto" (click)="deleteGroup(element)">
                                        <i class="ri-delete-bin-line"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<router-outlet></router-outlet>
